var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsNewWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.09998H21C21.122 2.09998 21.2384 2.12426 21.3445 2.16827C21.4506 2.21219 21.5501 2.27729 21.6364 2.36358C21.8121 2.53932 21.9 2.76965 21.9 2.99998V7.99998C21.9 8.49703 21.497 8.89998 21 8.89998C20.5029 8.89998 20.1 8.49703 20.1 7.99998V5.17277L14.6364 10.6364C14.2849 10.9878 13.7151 10.9878 13.3636 10.6364C13.0121 10.2849 13.0121 9.71505 13.3636 9.36358L18.8272 3.89998H16C15.5029 3.89998 15.1 3.49703 15.1 2.99998C15.1 2.50292 15.5029 2.09998 16 2.09998Z",
    fill: "curentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89998 6.99998C3.89998 6.3885 4.39056 5.89998 4.99998 5.89998H9.99998C10.497 5.89998 10.9 5.49703 10.9 4.99998C10.9 4.50292 10.497 4.09998 9.99998 4.09998H4.99998C3.39939 4.09998 2.09998 5.39145 2.09998 6.99998V19C2.09998 20.5956 3.39646 21.9 4.99998 21.9H17C18.597 21.9 19.9 20.597 19.9 19V14C19.9 13.5029 19.497 13.1 19 13.1C18.5029 13.1 18.1 13.5029 18.1 14V19C18.1 19.6029 17.6029 20.1 17 20.1H4.99998C4.3935 20.1 3.89998 19.6044 3.89998 19V6.99998Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsNewWindow);
export default __webpack_public_path__ + "static/media/icons-new-window.a625ce2cd5a847faaa0e65c5c0bacf47.svg";
export { ForwardRef as ReactComponent };